import { render } from "./GTSelect.vue?vue&type=template&id=6127da8a&scoped=true"
import script from "./GTSelect.vue?vue&type=script&lang=js"
export * from "./GTSelect.vue?vue&type=script&lang=js"

import "./GTSelect.vue?vue&type=style&index=0&id=6127da8a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6127da8a"]])

export default __exports__